"use server";

import { requireServerRole } from "@/lib/guards";
import {
  addInternalAccountSchema,
  editInternalAccountSchema,
  deleteInternalAccountSchema,
} from "@/lib/schemas/internal-accounts";
import { validateParams } from "@/lib/utils";
import { prisma } from "@/prisma";
import z from "zod";
import { GRP_ROLE_ADMIN } from "@/lib/grp";
import { ActionResult } from "@/types/server-action";

export async function deleteInternalAccount(
  params: z.infer<typeof deleteInternalAccountSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { id } = validateParams(deleteInternalAccountSchema, params);

    await prisma.internalAccount.update({
      where: { id },
      data: { deletedAt: new Date() },
    });

    return { success: true };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function addInternalAccount(
  params: z.infer<typeof addInternalAccountSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { name, siret } = validateParams(addInternalAccountSchema, params);

    const internalAccount = await prisma.internalAccount.create({
      data: { name, siret, isActive: true },
    });

    return { success: true, data: internalAccount };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function editInternalAccount(
  params: z.infer<typeof editInternalAccountSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      id = -1,
      name,
      siret,
      isActive = true,
    } = validateParams(editInternalAccountSchema, params);

    const internalAccount = await prisma.internalAccount.update({
      where: { id },
      data: { name, isActive, siret },
    });

    return { success: true, data: internalAccount };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
